export default __webpack_public_path__ + "static/vikrant2-85caf6911c6eeabc959b635147b2ae8d.jpg";